import React from 'react';
import { NavLink } from 'react-router-dom';

const MaestroSidebarMenu: React.FC = () => (
  <nav className='mc-submenu'>
    <NavLink to='/maestro-contabil/setup' activeClassName='is-active'><i className='bi bi-gear' /> Setup</NavLink>
    <NavLink exact to='/maestro-contabil' activeClassName='is-active'><i className='bi bi-speedometer2' /> Cockpit</NavLink>
    <NavLink to='/maestro-contabil/logs' activeClassName='is-active'><i className='bi bi-shield-lock' /> Logs (SOX)</NavLink>
    <NavLink to='/maestro-contabil/notificacoes' activeClassName='is-active'><i className='bi bi-bell' /> Notificações</NavLink>
    <NavLink to='/maestro-contabil/fiscal' activeClassName='is-active'><i className='bi bi-receipt' /> Apuração Tributária</NavLink>
    <NavLink to='/maestro-contabil/relatorio' activeClassName='is-active'><i className='bi bi-file-earmark-text' /> Relatório Mensal</NavLink>
  </nav>
);

export default MaestroSidebarMenu;
